import React from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { API_URL } from "../../services/api";

const Search = ({ setPaginate, url, originalUrl }) => {
    const searchForms = (e) => {
        const filter = e.target.value;
        if (filter.length >= 3) {
            setPaginate(`/api/search/${url}/${filter}`);
        }
        if (filter.length == 0) {
            setPaginate(API_URL + originalUrl);
        }
    };

    return (
        <InputGroup className="mb-3 ">
            <Form.Control
                id="search-form"
                placeholder="Buscar"
                aria-describedby="inputGroup-sizing-sm"
                onChange={(e) => {
                    searchForms(e);
                }}
            />
        </InputGroup>
    );
};

export default Search;
